import React, { useState, useEffect } from "react";

import { ListBoxModal, FormInput_text, ConfirmationModal } from "components";

import { func_validation } from "functions";
import { licenseColumns } from "../licenseColumns";
import ic_reset from "assets/images/ic_reset.svg";
import ic_edit from "assets/images/ic_edit.svg";
import ic_delete_invoices from "assets/images/ic_delete_invoices.svg";
import { Toaster } from "components/notification/Toaster";


export function useLicenseControl(props) {
    const { 
        packageList,

        comID,

        isSuspended: isSuspended_props,

        getPackageList_requesting,

        getLicenseList_requesting, 
        licenseList, licenseListHeaders,

        addLicense_requesting, addLicense_status,
        resetLicense_status,
        deleteLicense_requesting, deleteLicense_status,
        updateLicenseRemark_requesting, updateLicenseRemark_status,
    } = props;

    let comID_validated = func_validation.isNotNullUndefined(comID)? comID: "";


    // States
    const [isAddLicenseAttemped, setIsAddLicenseAttemped] = useState(false);
    const [isLicenseModalVisible, setIsLicenseModalVisible] = useState(false);
    const [validatedLicenseList, setValidatedLicenseList] = useState(false);
    const [remarks, setRemarks] = useState("");

    const [isModalVisible_deleteLicense, setIsModalVisible_deleteLicense] = useState(false);
    const [isModalVisible_updateLicenseRemark, setIsModalVisible_updateLicenseRemark] = useState(false);
    const [selectedLicense, setSelectedLicense] = useState([]);

    function getLicenseList(pageNo, pageSize, sort, filterOptions) {
        if (props.getLicenseList)
            props.getLicenseList(comID_validated, pageNo, pageSize, sort, filterOptions);
    }

    useEffect(() => {
        if (func_validation.isArrayNotEmpty(licenseList)) {
            let validatedList = licenseList.map((license) => {
                let validatedLicense = {
                    ...license,
                    status:
                        func_validation.isStringEmpty(license?.deletedDate) ||
                        func_validation.isNullUndefined(license?.deletedDate)
                        ? true
                        : false,
                    };
                return validatedLicense;
            });
            setValidatedLicenseList(validatedList);
        }
        else {
            setValidatedLicenseList([]);
        }
    }, [licenseList])

    function getPackageList() {
        if (props.getPackageList)
            props.getPackageList();
    }
    useEffect(() => {
        getPackageList();
    }, []);

    function handleAddLicense(packageID) {
        setIsAddLicenseAttemped(true);

        if (func_validation.isNumberValid(packageID) &&
            func_validation.isNumberValid(comID_validated) &&
            props.addLicense) {

            let licenseInfo = {
                "comId": comID_validated,
                "packageId": packageID,
                "company": "maxis",
                "remarks": remarks
            };
            props.addLicense(licenseInfo);
        }
    }

    useEffect(() => {
        setIsAddLicenseAttemped(false);

        if(isLicenseModalVisible)
            setRemarks("");
    }, [isLicenseModalVisible]);
    useEffect(() => {
        if (func_validation.isBooleanTrueNotNullUndefined(addLicense_status))
            setIsLicenseModalVisible(false);
    }, [addLicense_status]);


    let licenseOptions = [];
    if (func_validation.isArrayNotEmpty(packageList)) {
        licenseOptions = packageList.map((packageDetails, idx) => {
            let packageId = func_validation.getObjectPropertyValue(packageDetails, "packageId");
            let packageName = func_validation.getObjectPropertyValue(packageDetails, "packageName");

            return {
                label: packageName,
                value: packageId
            }
        });
    }

    let addLicenseModal = (
        <ListBoxModal
            isModalVisible={isLicenseModalVisible}

            title={"Add License"}

            header={"Package ID"}

            list={licenseOptions.map((obj) => {
                return obj?.value;
            })}
            labelList={licenseOptions.map((obj) => {
                return obj?.label;
            })}

            updateParentState={setIsLicenseModalVisible}

            modalWapperClassName={"distributorPortal-companyOverview-lincenseModal"}

            isListLoading={getPackageList_requesting}
            isListRadio

            isInputRequired 
            isFormSubmissionAttempted={isAddLicenseAttemped}
            
            actionTxt={"Add"}
            handleOnConfirm={handleAddLicense}
            actionStatus={addLicense_status}
            isActionLoading={addLicense_requesting}
            isClosedOnSuccess isListBoxHeaderHidden

            bottomContent={(
                <div className={"distributorPortal-companyOverview-lincenseModal-remarks"}>
                    <FormInput_text
                        inputValue={remarks}
                        propagateValueChange={(stateName, value) => { setRemarks(value); }}

                        inputLabel={"Tag (Remark)"}
                        isInputOptional
                        isMarginBtmOptional
                    />
                </div>
            )}
        />
    );

    function handleLicense_reset(selectedRows) {
        if (func_validation.isArrayNotEmpty(selectedRows) &&
            func_validation.isArrayLengthEqual(selectedRows, 1)) {

            // get and check device id
            let deviceid = func_validation.getObjectPropertyValue(selectedRows[0], "deviceId");
            if(func_validation.isStringNotEmpty(deviceid)) {
                // get license key
                let licenseKey = func_validation.getObjectPropertyValue(selectedRows[0], "licenseKey");
                // check com id and license key
                if (func_validation.isStringNotEmpty(licenseKey) &&
                    func_validation.isNumberValid(comID_validated) &&
                    props.resetLicense) {

                    let licenseInfo = {
                        "comId": comID_validated,
                        "licenseKey": licenseKey
                    };
                    props.resetLicense(licenseInfo);
                }
            }
            else {
                Toaster({ type: "info", msg: "To perform a reset, the license must be bound to a device. Please bind the license to a device before proceeding." });
            }
        }
        else if (func_validation.isArrayEmpty(selectedRows))
            Toaster({ type: "info", msg: "Please select a row" });
        else Toaster({ type: "info", msg: "Only one license can be reset at a time" });
    }

    function handleLicense_delete(selectedRows) {
        if (func_validation.isArrayNotEmpty(selectedRows)) {
            setSelectedLicense(selectedRows);
            setIsModalVisible_deleteLicense(true);
        }
        else if (func_validation.isArrayEmpty(selectedRows))
            Toaster({ type: "info", msg: "Please select a row" });
    }

    function deleteLicense() {
        selectedLicense.map(obj => {
            let deviceid = func_validation.getObjectPropertyValue(obj, "deviceId");
            let licenseKey = func_validation.getObjectPropertyValue(obj, "licenseKey");
            if (func_validation.isStringNotEmpty(licenseKey) && func_validation.isNumberValid(comID_validated) &&
                props.deleteLicense) {
                    
                let licenseInfo = {
                    "comId": comID_validated,
                    "deviceId": deviceid ? deviceid : "",
                    "licenseKey": licenseKey
                };
                props.deleteLicense(licenseInfo);
            }
            else {
                Toaster({ 
                    type: "error",
                    msg: `Unable to delete license`
                });
            }
        })
    }

    let deleteLicenseModalDisplay = (
        <ConfirmationModal
            description={"The selected license will be deleted."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_deleteLicense}
            updateParentState={setIsModalVisible_deleteLicense}
            handleOnConfirm={deleteLicense}
            isConfirmSuccessful={deleteLicense_status}
            isActionLoading={deleteLicense_requesting}
        />
    );

    function handleLicense_updateRemark(selectedRows) {
        if (func_validation.isArrayNotEmpty(selectedRows)) {
            setRemarks("");
            setSelectedLicense(selectedRows);
            setIsModalVisible_updateLicenseRemark(true);
        }
        else if (func_validation.isArrayEmpty(selectedRows))
            Toaster({ type: "info", msg: "Please select a row" });
    }

    function updateLicenseRemark() {
        selectedLicense.map(obj => {
        //   check com id and license id
          let licenseId = func_validation.getObjectPropertyValue(obj, "id");
          if (func_validation.isNumberValid(comID_validated) && func_validation.isNumberValid(licenseId) &&
              props.updateLicenseRemark) {
                let licenseInfo = {
                  comId: comID_validated,
                  remarks: remarks,
                };
                props.updateLicenseRemark(licenseId, licenseInfo);
              }
          else {
              Toaster({
                  type: "error",
                  msg: `Unable to update license remark`
              });
          }
        })
    }

    let updateLicenseRemarkModalDisplay = (
        <ConfirmationModal
            description={"Updating selected license tag (Remark)"}
            bodyFooterClassName={"account-control__modal"}
            input={(
                <div className={"inputs-wrapper__inputs d-flex pb-3"}>
                    <FormInput_text
                        className={"inputs__new-billing-tag w-100"}
                        customInputClassName={"w-100"}
                        inputValue={remarks}
                        propagateValueChange={(stateName, value) => { setRemarks(value); }}

                        inputLabel={"Tag (Remark)"}
                        isInputOptional
                        isMarginBtmOptional
                    />
                </div>
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_updateLicenseRemark}
            updateParentState={setIsModalVisible_updateLicenseRemark}
            handleOnConfirm={updateLicenseRemark}
            isActionLoading={updateLicenseRemark_requesting}
            isConfirmSuccessful={updateLicenseRemark_status}
        />
    );

    function getLicenseMenuItems(selectedRows) {
        return [
            {
                icon: ic_edit,
                label: "Edit tag (Remark)",
                isDisabled: isSuspended_props,
                onClick: () => { handleLicense_updateRemark(selectedRows); },
            },
            {
                icon: ic_reset,
                label: "Reset license key",
                isDisabled: isSuspended_props,
                onClick: () => { handleLicense_reset(selectedRows); },
            },
            {
                icon: ic_delete_invoices,
                label: "Delete",
                onClick: () => { handleLicense_delete(selectedRows); },
            }
        ];
    };

    return {
        getLicenseList,
        addLicenseModal,

        addLicense_status,
        resetLicense_status,
        deleteLicense_status,
        updateLicenseRemark_status,
        getLicenseList_requesting, 
        validatedLicenseList, licenseListHeaders,

        licenseColumns: licenseColumns.getColumns(props),

        setIsLicenseModalVisible,
        getLicenseMenuItems,
        deleteLicenseModalDisplay,
        updateLicenseRemarkModalDisplay
    };
}
